/* eslint-disable max-len */

import { FC } from "react";
import { IIcon } from "./IIcon";

const PdfIcon: FC<IIcon> = ({
  //  color,
   className }) => {
  // const currentColor = color || "currentColor";
  return (
    <span className={className}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.33325 5.83268C3.82479 6.33838 5.13303 8.33268 5.83325 8.33268C6.53348 8.33268 7.84172 6.33838 8.33325 5.83268M5.83325 7.49935V1.66602"
          stroke="#E94310"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <path
          d="M3.33325 10.8327V12.1195C3.33325 14.8237 3.33325 16.1758 4.07164 17.0916C4.22082 17.2766 4.38934 17.4451 4.57436 17.5943C5.49018 18.3327 6.84227 18.3327 9.54642 18.3327C10.1344 18.3327 10.4283 18.3327 10.6976 18.2377C10.7536 18.2179 10.8084 18.1952 10.862 18.1696C11.1196 18.0463 11.3274 17.8385 11.7432 17.4228L15.6903 13.4757C16.172 12.9939 16.4128 12.7531 16.5398 12.4468C16.6666 12.1405 16.6666 11.7998 16.6666 11.1186V8.33268C16.6666 5.18998 16.6666 3.61864 15.6903 2.64232C14.714 1.66602 13.1426 1.66602 9.99992 1.66602M10.8333 17.916V17.4993C10.8333 15.1423 10.8333 13.9638 11.5655 13.2316C12.2978 12.4993 13.4763 12.4993 15.8333 12.4993H16.2499"
          stroke="#E94310"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
      </svg>
    </span>
  );
};

export default PdfIcon;
